import { render, staticRenderFns } from "./LeaderRanking.vue?vue&type=template&id=5f88f193&scoped=true"
import script from "./LeaderRanking.vue?vue&type=script&lang=js"
export * from "./LeaderRanking.vue?vue&type=script&lang=js"
import style0 from "./LeaderRanking.vue?vue&type=style&index=0&id=5f88f193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88f193",
  null
  
)

export default component.exports